<template>
    <div class="main-container">
        <slot></slot>
    </div>
</template>

<script>
    import Vue from 'vue'
    export default Vue.extend({})
</script>

<style lang="sass" scoped>
.main-container
    +main-container()
</style>